module.exports = __webpack_public_path__ + "img/currency-line.77a881a2.svg";